import { DaysOfWeekSchedule } from '../schema/days-of-week-schedule.schema';
import { DaysOfWeekScheduleValidator } from '../validators/index';

export const isDaysOfWeekSchedule = (
  value: unknown,
): value is DaysOfWeekSchedule => DaysOfWeekScheduleValidator.Check(value);
